export function slugify(str) {
  return str
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')      
    .trim()
    .replace(/\s+/g, '-')          
    .replace(/-+/g, '-');         
}
